<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@2.0.0-rc.5/dist/quill.bubble.css" />
<!-- style="width: 400px;width: 400px;" -->
<div class="border-2 border-blue-600 " matTooltip="html編輯,區域選擇出現功能表">
  <quill-editor #editor class="w-full" style="min-height: 48px;" [(ngModel)]="html"
    (onContentChanged)="quillEditorReady($event)"></quill-editor>
</div>

<!-- <quill-editor #editor class="w-full" style="min-height: 48px;" [(ngModel)]="html" theme="bubble"
    modules="quillEditorOptions" placeholder="請輸入html內容" (onContentChanged)="quillEditorReady($event)"></quill-editor> -->